import { useContext, useEffect, useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import CVC from "../../Assets/Images/CVC.svg";
//assets
import mastercard from '../../Assets/Images/mastercard.png';
import ax from '../../Assets/Images/ax.png';
import jcb from '../../Assets/Images/jcb.png';
import visa from '../../Assets/Images/visa.png';
import dummycard from '../../Assets/Images/dummycard.png';
import Logo from '../../Assets/Images/logo.png'
// import stripe from "../../Assets/Images/stripe.svg"
import stripe from '../../Assets/Images/stripe-logo-new.svg'
import Alert from '../../Assets/Images/alert.svg'

//components
import CheckoutForm from "../../Components/Stripe/CheckoutForm";
import Stepper from "../../Components/Registration/Stepper";

//libs
import { CircularProgress } from "@mui/material";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import AuthContext from "../../Context/AuthContext";
import CheckoutFormV2 from "../../Components/Stripe/CheckoutFormV2";
import TPLogo from '../../Assets/Images/TPLogo.png';
import NewTPLogo from '../../Assets/Images/whiteLogo.png';

import TermsAndConditions from "../../Modals/TermsAndConditionsModal/TermsAndConditions";


const SignupPayment = () => {
  const authCtx = useContext(AuthContext);
  const navigate = useNavigate();
  
  const location = useLocation()
  const params = new URLSearchParams(location.search)
  const locationState = location?.state
  console.log('locationState', locationState)

  const isReturningUser = params?.get("returning") === "true"

  let fromLoginPage;

  if ( locationState?.fromLoginPage ) {
    fromLoginPage = locationState?.fromLoginPage
  }

  const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_API_KEY);

  // const { id } = useParams();
  const id = authCtx?.orgId || localStorage.getItem('orgId');

  const [isLoading, setIsLoading] = useState(true);
  const [clientSecret, setClientSecret] = useState("");
  const [showPayment, setShowPayment] = useState(false);
  const [couponCode, setCouponCode] = useState("");
  const [error, setError] = useState("");
  const [originalAmount] = useState(10); // Original amount is fixed
  const [amount, setAmount] = useState(originalAmount);
  const [canNavigate, setCanNavigate] = useState(true);
  const [couponCodeError, setCouponCodeError] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false)


  const couponCodes = [
    { code: 'QUADRANT100', discount: 100 },
    { code: 'QUADRANT80', discount: 80 },
    { code: 'QUADRANT50', discount: 50 },
    { code: 'QUADRANT25', discount: 25 }
  ];

  const appearance = {
    theme: 'stripe',
  };
  const options = {
    clientSecret,
    appearance,
  };

  useEffect(() => {
    if (amount > 0) {
      initiatePaymentIntent(amount);
    } else {
      setIsLoading(false);
    }
  }, []);

  const initiatePaymentIntent = (payloadAmount) => {
    const payload = {
      email: authCtx.email,
      name: authCtx.userName,
      amount: payloadAmount,
      currency: "usd"
    };

    fetch(`${process.env.REACT_APP_API_URI}/v4/organisation/paymentIntent`, {
      method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Authorization': authCtx.token },
      body: JSON.stringify(payload),
    })
    .then((res) => res.json())
    .then(data => {
      setClientSecret(data.clientSecret);
      setShowPayment(true);
      setIsLoading(false);
    });
  };

  // const handleApplyCoupon = () => {
  //   if ( couponCode == "QUADRANT100" ) {
  //     navigate("/dashboard");
  //   }
  // };

  const handleApplyCoupon = () => {
    const coupon = couponCodes.find(c => c.code === couponCode);

    if (coupon) {
      const newAmount = originalAmount - (originalAmount * (coupon.discount / 100));
      console.log(newAmount);
      setAmount(newAmount);
      if (newAmount > 0) {
        initiatePaymentIntent(newAmount);
      } else {
        navigate("/dashboard");
        setClientSecret(""); // No need for Stripe if the amount is 0
      }
      setCouponCodeError("");
    } else {
      setCouponCodeError("Invalid coupon code.");
    }
  };

  const handleContinue = () => {
    if (canNavigate) {
      putOrganizationStatus(id);
      navigate("/payment-confirmed", {
        state: {
          paymentPage: "complete"
        }
      });
    } else {
      alert("Please complete the payment details or apply a valid coupon.");
    }
  };

  const putOrganizationStatus = (id) => {
    const payload = {
      status: "paid",
      email: authCtx.email,
      name: authCtx.email,
      amount: amount,
    };

    fetch(`${process.env.REACT_APP_API_URI}/v4/organisation/${id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': authCtx.token
      },
      body: JSON.stringify(payload),
    })
    .then((res) => {
      if (res.ok) {
        // console.log("Organization status updated to 'paid'.");
      } else {
        console.error("Failed to update organization status.");
      }
    })
    .catch((error) => {
      console.error("Error updating organization status:", error);
    });
  };


  const showPaymentInfo = () => {
    if (isLoading) {
      return <div className="network-info"><CircularProgress style={{ 'color': '#F7D54D' }} size={60} /></div>;
    }

    if (clientSecret) {
      return (
        <Elements options={options} stripe={stripePromise}>
          <CheckoutForm stripeSecret={clientSecret} userId={1} orgId={id} />
        </Elements>
      );
    } else if (amount === 0) {
      return (
        <button className="continue-button" onClick={handleContinue}>Continue</button>
      );
    }

    return null;
  };

  const goToLogin = (e) => {
    e.preventDefault();
    navigate('/login');
  }

  const goToTermsAndConditions = (e) => {
    e.preventDefault();
    window.open('/terms-and-conditions', '_blank');
};

  const handleSkip = () => {
    navigate('/dashboard')
  }

console.log('fromLoginPage', fromLoginPage)

  return (
    <div className="container signup-payment-container">
      <div className="inner-container">
      <div className="left">
        <img src={NewTPLogo} alt="Logo" style={{ width: "113", height: "129" , objectFit: "contain"}} />
        <h1>Welcome to the <br /> Quadrant Flow Portal  </h1>
      </div>
        <div className="right">
          {/* Removed parent <form> to avoid nested forms */}
          <div className="form">
          <h2 style={{ width: isReturningUser !== true ? "400px" : "450px" }}>{isReturningUser !== true ? "Create your account" : "Complete account creation"}</h2>
            {/* <p className="form-subtitle">Add your payment details</p> */}
            <Stepper steps={{ current: 3, total: 3 }} />
            
            {/* <div className="coupon-code-div">
              <label htmlFor="coupon-code" className="coupon-code-label">Coupon Code (optional)</label>
              <input 
                type="text" 
                placeholder="Coupon Code" 
                className="coupon-code" 
                value={couponCode} 
                onChange={(e) => setCouponCode(e?.target?.value?.toUpperCase())} 
              />
              <button type="button" className="apply-coupon-button" onClick={handleApplyCoupon}>Apply</button>
              {error && <p className="error-message">{error}</p>}
            </div> */}

            {/* Show card information only if couponCode is not entered */}
            {amount !== 0 ? (
              <>
                <div className="input-box card-details-input">
                  <label htmlFor="card">Card Information<span className="asterisk-mark">*</span></label>
                  <CheckoutFormV2 />
                </div>
              </>
            ) : null}

            {/* Always show the Create Account button */}
            {/* <button type="submit" className="create-account" onClick={handleContinue} disabled={!canNavigate}>Create your account</button> */}
          </div>

          <div className="skip-info-container">
            <img src={Alert} alt="" />
            <p className="skip-information">Your card won’t be charged right now. We’re just saving it as your primary payment method. You can update it anytime.</p>
          </div>
          <button className="skip-btn" onClick={handleSkip}>Add card details later</button>
          
          <div className="footer">
            <div className="upper-box"><span className="powered-by">Powered by</span> <img src={stripe} alt="stripe" className="stripe-logo" /></div>
            <div className="inner-box" onClick={() => setIsModalOpen(true)}>
              <p>Terms and Conditions</p>
              {/* <p>Privacy</p> */}
            </div>
            <TermsAndConditions isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
              <div className='terms-and-conditions-wrapper'>
                <h1 className='terms-heading'>Terms and Conditions</h1>
                <div className="terms-container">
                  <p className="heading-two">Terms and Agreements for Creating an Account:</p>
                  <div className="quadrant-head">Quadrant Flow Consultant Terms and Conditions</div>
                  <div className="quadrant-info">By creating an account as a consultant on the Quadrant Flow platform, you agree to the following terms and conditions:</div>
                    
                    <p className="quadrant-info-points">1.  <span>Eligibility:</span> You confirm that you have been certified or granted access by Transformational Performance & Transformed Leader, the creators of Quadrant Flow, to create an account on the Quadrant Flow platform. Quadrant Flow reserves the right to verify your certification or authorization and may deny access if necessary.</p>
                    <p className="quadrant-info-points">2.  <span>Confidentiality:</span> You agree to maintain the confidentiality of any client information, assessment results, or proprietary content accessed through Quadrant Flow. This includes, but is not limited to, client identities, personal data, and Quadrant Flow materials.</p>
                    <p className="quadrant-info-points">3.  <span>Use of Platform:</span> You will use the Quadrant Flow platform, a product of Transformational Performance & Transformed Leader, solely for professional consulting and leadership development purposes. Misuse of the platform, including unauthorized sharing of content or engagement in inappropriate activities, may result in the termination of your account.</p>
                    <p className="quadrant-info-points">4.  <span>Intellectual Property:</span> All content provided by Quadrant Flow, including assessments, tools, and resources, is the intellectual property of Transformational Performance & Transformed Leader. You are granted a limited, non-transferable license to use this content for consulting purposes within the platform. You may not reproduce, distribute, or modify any content without prior written consent.</p>
                    <p className="quadrant-info-points">5.  <span>Professional Conduct:</span> You agree to act in a professional and ethical manner when interacting with clients, colleagues, and Quadrant Flow staff. Any form of harassment, discrimination, or unprofessional behavior will not be tolerated and may lead to account suspension or termination.</p>
                    <p className="quadrant-info-points">6.  <span>Tokens:</span> Consultants are required to purchase tokens to access certain services and assessments on the Quadrant Flow platform. All token purchases are non-refundable and will expire 12 months after the date of purchase, unless otherwise agreed to by Transformational Performance & Transformed Leader in specific cases.</p>
                    <p className="quadrant-info-points">7.  <span>Liability:</span> Quadrant Flow and its parent organizations, Transformational Performance & Transformed Leader, are not liable for any actions, advice, or outcomes resulting from your consulting services. You assume full responsibility for the guidance and services provided to clients through the platform.</p>
                    <p className="quadrant-info-points">8.  <span>Account Termination:</span> Quadrant Flow reserves the right to terminate or suspend your account at any time for violation of these terms or any other reasons deemed necessary by the platform.</p>
                    <p className="quadrant-info-points">9.  <span>Amendments:</span> Quadrant Flow may update these terms and conditions from time to time. You will be notified of any significant changes, and continued use of the platform will constitute acceptance of the revised terms.</p>
                    
                  <p className="footer-sentence">By creating an account, you acknowledge that you have read, understood, and agreed to these terms and conditions.</p>
                </div>
              </div>
            </TermsAndConditions>
          </div>
        </div>
      </div>
      {/* <h1>Payment Setup</h1>
      <div className="payment-form">
        <div className="amount-details">
          <div className="subscription">Yearly Total</div>
          <div className="price">${amount.toFixed(2)}</div>
        </div>
        <div className="payment-container">
          <div className="coupon-code-div">
            <label htmlFor="coupon-code" className="coupon-code-label">Coupon Code (optional)</label>
            <input type="text" placeholder="Coupon Code" className="coupon-code" value={couponCode} onChange={(e) => setCouponCode(e.target.value)} />
            <button type="button" className="apply-coupon-button" onClick={handleApplyCoupon}>Apply</button>
            {error && <p className="error-message">{error}</p>}
          </div>
          {showPaymentInfo()}
        </div>
      </div> */}
    </div> 
  );
}

export default SignupPayment;
